import {Component, Input, OnInit, ViewChild} from '@angular/core';
import backendResponseData, {
  fullSubstitutionDataToSend,
  PlayerReplacerService
} from "../../services/player-replacer.service";
import {NgbTypeahead} from "@ng-bootstrap/ng-bootstrap";
import {distinctUntilChanged, map, Observable, OperatorFunction} from "rxjs";
import {DuelSeriesViewComponent} from "../duel-series-view/duel-series-view.component";
import {DuelViewsServiceService} from "../../services/duel-views-service.service";
import {BracketItemService} from "../../services/bracket-item.service";

@Component({
  selector: 'app-player-replacer',
  templateUrl: './player-replacer.component.html',
  styleUrls: ['./player-replacer.component.scss']
})
export class PlayerReplacerComponent implements OnInit {

  @Input() currentPlayerId: number;
  @Input() currentDuelId: number;
  @Input() tournamentId: number;
  @Input() duelIdToUpdateBrackets: number;

  public erroneous: boolean = false;
  private _choseSubstitution: any;
  private _substitutionToSend;
  private _substitutionInterfaceOpened: boolean = false;
  private _nameSurnameSeparator: string = ' ';
  private _substituteButtonStatesToCSS = {
    active: 'btn btn-log btn-sm',
    disabled: 'blockedSubstituteButtonStyle',
  };

  private _openedClosed = {
    opened: 'substitutionInterfaceCommonStyle',
    closed: 'substitutionInterfaceCommonStyle buttonOnly',
  }

  constructor(
    private playerReplacerService: PlayerReplacerService,
    private duelSeriesViewService: DuelViewsServiceService,
    private bracketItemService: BracketItemService,
  ) { }

  ngOnInit(): void {
    // perhaps mountedComponentInstances will be demanded by ones needs later
    this.playerReplacerService.mountedComponentInstances ++;

    if (this.tournamentId || this.tournamentId === 0) {
      this.playerReplacerService.tournamentIdentifier = this.tournamentId;
      this.playerReplacerService.getListOfSubstitutes().subscribe((substitutesList: backendResponseData) => {

        substitutesList.results.forEach((substituteData) => {
          const reversedName = substituteData.full_name.split(this._nameSurnameSeparator).reverse().join(this._nameSurnameSeparator)

          if (!this.playerReplacerService.listOfPlayersToIgnore.includes(reversedName)) {
            this.dictOfSubstitutes[reversedName] = {
              ds_number: substituteData.ds_number,
              player_id: substituteData.player_id,
            };
          }
        });
      });

    }
  }

  ngOnDestroy(): void {
    this.playerReplacerService.mountedComponentInstances --;
  }

  playerInputFormatter = (player: string) => player;
  playerOutputFormatter = (player: string) => player;

  @ViewChild('instance', {static: true}) instance: NgbTypeahead;

  searchASubstitute: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {

    return text$.pipe(
      distinctUntilChanged(),
      map(term => {
        return term === '' ? Object.keys(this.dictOfSubstitutes)
          : Object.keys(this.dictOfSubstitutes).filter(v => v.toLowerCase().startsWith(term.toLowerCase()));
      })
    );
  }

  get dictOfSubstitutes() {
    return this.playerReplacerService.formattedDictOfSubstitutes
  }

  set dictOfSubstitutes(object) {
    this.playerReplacerService.formattedDictOfSubstitutes = object;
  }

  get substitutionToSend() {
    return this._substitutionToSend;
  }

  set substitutionToSend(object) {
    this._substitutionToSend = object;
  }

  get substitutionInterfaceOpened(): boolean {
    return this._substitutionInterfaceOpened;
  }

  set substitutionInterfaceOpened(value) {
    this._substitutionInterfaceOpened = value;
  }

  substituteClickHandler() {
    this.substitutionInterfaceOpened = true;
  }

  declineSubstitutionClickHandler() {
    this.substitutionInterfaceOpened = false;
    this.choseSubstitution = '';
  }

  substitutionPermitted(): boolean {
    return Object.keys(this.dictOfSubstitutes).includes(this.choseSubstitution);
  }

  acceptSubstitutionClickHandler() {

    if (this.substitutionPermitted()) {
      this.substitutionInterfaceOpened = false;
      const substitutionData: fullSubstitutionDataToSend = {
        ds_from_num: this.currentDuelId,
        ds_from_player: this.currentPlayerId,
        ds_to_num: this.dictOfSubstitutes[this.choseSubstitution].ds_number,
        ds_to_player: this.dictOfSubstitutes[this.choseSubstitution].player_id,
      };
      this.playerReplacerService.substitute(substitutionData).subscribe(() => {
        this.choseSubstitution = '';
        // this.duelSeriesViewService.watchPlayersReplaceEventEmitter.emit(this.duelSeriesViewService.updateDuePlayerReplace);
        this.bracketItemService.updateAll();
      });
    }
  }

  substituteButtonStyle(): string {
    return this.substitutionPermitted()
      ? this._substituteButtonStatesToCSS.active
      : this._substituteButtonStatesToCSS.disabled;
  }

  substitutionInterfaceCSS(): string {
    return this.substitutionInterfaceOpened
      ? this._openedClosed.opened
      : this._openedClosed.closed;
  }

  get choseSubstitution(){
    return  this._choseSubstitution;
  }

  set choseSubstitution(value) {
    this._choseSubstitution = value;
  }




}
